import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SideBarButton from '../SideBar/SideBarButton';
import { SideBarInner } from '../../styled-components/SideBar';

const CloseEditImage = 'images/delete.png';
const Insert = 'images/id_card_add.png';
const PublishImage = 'images/publish.png';

class ClipperSidebarContent extends PureComponent {
  onClose = () => {
    window.close();
  };

  render() {
    const { mediaEngineEnabled, publishingEnabled } = this.props;
    return (
      <SideBarInner>
        <SideBarButton
          align="flex-start"
          text="Exit Editor"
          image={CloseEditImage}
          onClick={this.onClose}
        />
        {mediaEngineEnabled && publishingEnabled ? (
          <SideBarButton
            align="flex-end"
            text="Publish"
            image={PublishImage}
            disabled={!this.props.movieSelected}
            onClick={this.props.publish}
          />
        ) : (
          ''
        )}
        {this.props.insertToScript ? (
          <SideBarButton
            align="flex-end"
            text="Insert"
            image={Insert}
            disabled={!this.props.movieSelected}
            onClick={this.props.insertToScript}
          />
        ) : (
          ''
        )}
      </SideBarInner>
    );
  }
}

ClipperSidebarContent.defaultProps = {
  insertToScript: null
};

ClipperSidebarContent.propTypes = {
  movieSelected: PropTypes.bool.isRequired,
  insertToScript: PropTypes.func,
  publish: PropTypes.func.isRequired,
  mediaEngineEnabled: PropTypes.bool.isRequired,
  publishingEnabled: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  appRunMode: state.app.appRunMode,
  mediaEngineEnabled:
    state.app.connections.mediaEngine.connected && state.app.connections.mediaEngine.licensed,
  publishingEnabled:
    state.app.connections.publishing.connected && state.app.connections.publishing.licensed
});

export default connect(mapStateToProps)(ClipperSidebarContent);



// WEBPACK FOOTER //
// ./app/components/Clipper/ClipperSidebarContent.js